var map = {
	"./default-shop-banner.png": "d842",
	"./default-shop-logo.png": "ee73",
	"./default-shop.png": "8b86",
	"./wgt-ab-test.png": "c9bf",
	"./wgt-around-service.png": "1e79",
	"./wgt-around-store.png": "23d52",
	"./wgt-classify.png": "5209",
	"./wgt-coupon.png": "785e",
	"./wgt-custom-wgt.png": "c096",
	"./wgt-film.png": "d2e6",
	"./wgt-floorImg.png": "ee20",
	"./wgt-footer_nav.png": "d24b",
	"./wgt-goods-grid-tab.png": "7606",
	"./wgt-goods-list.png": "d4fb",
	"./wgt-goods-scroll.png": "b6f9",
	"./wgt-goodsgrid.png": "b28b",
	"./wgt-headline.png": "1efa",
	"./wgt-horizontal.png": "bb5e",
	"./wgt-hotTopic.png": "8612",
	"./wgt-hotzone.png": "7431",
	"./wgt-image-text.png": "22c7",
	"./wgt-img-navigation.png": "278b",
	"./wgt-marquees.png": "becca",
	"./wgt-member-info.png": "c1c1",
	"./wgt-nearby-shop.png": "ff36a",
	"./wgt-nearly-store.png": "20be",
	"./wgt-official-account.png": "0387",
	"./wgt-old-evaluate.png": "e615",
	"./wgt-productShelves.png": "da95",
	"./wgt-search.png": "c322",
	"./wgt-showcase.png": "0808",
	"./wgt-slider.png": "a8b1a",
	"./wgt-sticky-lift.png": "7300",
	"./wgt-store.png": "01b5",
	"./wgt-storeRuleList.png": "a7f2",
	"./wgt-suspension.png": "4592",
	"./wgt-tabsCut.png": "8bea",
	"./wgt-user-container.png": "87ba",
	"./wgt-wall-paper.png": "260d",
	"./wgt_content-part.png": "5674",
	"./区块滚动.png": "57db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab0f";